import { render, staticRenderFns } from "./webcome.vue?vue&type=template&id=44443637&scoped=true&"
import script from "./webcome.vue?vue&type=script&lang=js&"
export * from "./webcome.vue?vue&type=script&lang=js&"
import style0 from "./webcome.vue?vue&type=style&index=0&id=44443637&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44443637",
  null
  
)

export default component.exports